exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sedap-table-pagination{margin-top:2rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n", "", {"version":3,"sources":["/app/src/components(new)/UI/Tables/Pagination/styles.scss"],"names":[],"mappings":";AAAA,wBACE,gBACA,oBAAA,oBAAA,aACA,wBAAA,qBAAA,uBACA,yBAAA,sBAAA,kBAAmB;CACpB","file":"Pagination.vue","sourcesContent":[".sedap-table-pagination {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bc6c157a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components(new)/UI/Tables/Pagination/Pagination.vue
// module id = ocpW
// module chunks = 5